"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeString = exports.OrderType = void 0;
var OrderType;
(function (OrderType) {
    OrderType[OrderType["Private"] = 0] = "Private";
    OrderType[OrderType["Shared"] = 1] = "Shared";
})(OrderType || (exports.OrderType = OrderType = {}));
var OrderTypeString;
(function (OrderTypeString) {
    OrderTypeString["Private"] = "Private";
    OrderTypeString["Pool"] = "Pool";
    OrderTypeString["DayTrip"] = "DayTrip";
})(OrderTypeString || (exports.OrderTypeString = OrderTypeString = {}));
//# sourceMappingURL=OrderType.js.map